import { render, staticRenderFns } from "./RequestFAQ.vue?vue&type=template&id=a5c47210"
import script from "./RequestFAQ.vue?vue&type=script&lang=js"
export * from "./RequestFAQ.vue?vue&type=script&lang=js"
import style0 from "./RequestFAQ.vue?vue&type=style&index=0&id=a5c47210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports